import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ec58d7a4")
const _hoisted_1 = { class: "user" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      formConfig: _ctx.searchFormConfig,
      onQueryBtnClick: _ctx.handleQueryClick,
      onResetBtnClick: _ctx.handleResetClick
    }, null, 8, ["formConfig", "onQueryBtnClick", "onResetBtnClick"]),
    _createVNode(_component_PageContent, {
      ref: "pageContentRef",
      contentConfig: _ctx.contentConfig,
      pageName: "goods",
      onNewBtnClick: _ctx.handleNewData,
      onEditBtnClick: _ctx.handleEditData
    }, {
      image: _withCtx((scope) => [
        _createVNode(_component_el_image, {
          class: "image",
          src: scope.row.imgUrl,
          "preview-src-list": [scope.row.imgUrl]
        }, null, 8, ["src", "preview-src-list"])
      ]),
      oldPrice: _withCtx((scope) => [
        _createTextVNode("$" + _toDisplayString(scope.row.oldPrice), 1)
      ]),
      newPrice: _withCtx((scope) => [
        _createTextVNode("$" + _toDisplayString(scope.row.newPrice), 1)
      ]),
      _: 1
    }, 8, ["contentConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref: "pageModalRef",
      defaultInfo: _ctx.defaultInfo,
      modalConfig: _ctx.modalConfig,
      pageName: "department"
    }, {
      image: _withCtx((scope) => [
        _createVNode(_component_el_upload, {
          class: "avatar-uploader",
          action: "#",
          "show-file-list": false
        }, {
          default: _withCtx(() => [
            (_ctx.defaultInfo[scope.row.field])
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.defaultInfo[scope.row.field],
                  class: "avatar"
                }, null, 8, _hoisted_2))
              : (_openBlock(), _createElementBlock("i", _hoisted_3))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["defaultInfo", "modalConfig"])
  ]))
}